import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HubSpotBlogResponse } from 'projects/login/src/app/services/news/models/HubSpotModel';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  private readonly _httpClient = inject(HttpClient);

  getAll(lang: string) {
    return this._httpClient.get<HubSpotBlogResponse>(this.getPath(lang)).pipe(
      map((response) => {
        response.results = response.results.map((result) => {
          result.contentType = result.slug.includes('cases') ? 'case' : 'news';
          return result;
        });
        return response;
      }),
    );
  }

  private getPath(lang: string, itemId: string | undefined = undefined) {
    const path = 'v2/news';
    const languageQueryParam = `?lang=${lang}`;
    if (itemId) {
      return `${path}/item${languageQueryParam}&itemId=${itemId}`;
    } else {
      return `${path}${languageQueryParam}`;
    }
  }
}
